/* eslint-disable max-statements */

import { Image } from "@bluframe/mightychroma-mightytool-frontend-types"
import imagesConfig from "config/images"

const { DEVICE_SIZES, IMAGE_SIZES } = imagesConfig

// Type definition for the props that this function will receive.
interface Props {
  image: Pick<Image, "formats" | "url">
  width: number
}

const imageLoader = ({ image, width }: Props) => {
  const getUrl = (key: keyof Image["formats"]) =>
    image.formats[key]?.url ?? image.url

  const smallMax = Math.max(DEVICE_SIZES.mobile, IMAGE_SIZES.small)
  const mediumMax = Math.max(DEVICE_SIZES.tablet, IMAGE_SIZES.medium)
  const largeMax = Math.max(DEVICE_SIZES.desktop, IMAGE_SIZES.large)

  if (width <= IMAGE_SIZES.xsmall) return getUrl("xsmall")
  if (width <= IMAGE_SIZES.thumbnail) return getUrl("thumbnail")
  if (width <= smallMax) return getUrl("small")
  if (width <= mediumMax) return getUrl("medium")
  if (width <= largeMax) return getUrl("large")
  if (width <= IMAGE_SIZES.xlarge) return getUrl("xlarge")

  return image.url
}

export default imageLoader
